import { render } from "./ElementList.vue?vue&type=template&id=328f15a4&ts=true"
import script from "./ElementList.vue?vue&type=script&lang=ts"
export * from "./ElementList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__